exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarProveedor .h2_title[data-v-ba5f4422] {\n  font-weight: normal;\n}\n.btn-grabar[data-v-ba5f4422] {\n  background-color: #ff6c00 !important;\n  color: white !important;\n}\n", ""]);

// exports
